import React, { FC } from 'react';
import { Button, IconButton, Popover } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';

interface PopoverAction {
  title: string;
  action: any;
  color: any;
  hide?: boolean;
}

interface COEEllipsisPopoverProps {
  actions: PopoverAction[];
}

const COEEllipsisPopover: FC<COEEllipsisPopoverProps> = (props) => {
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  return (
    <div>
      <IconButton aria-describedby={id} onClick={handleClick}>
        <MoreVertIcon />
      </IconButton>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          {props.actions
            .filter((item) => !item.hide)
            .map((action: PopoverAction) => (
              <Button
                key={action.title}
                variant="text"
                color={action.color}
                size="small"
                style={{ width: 100 }}
                onClick={(evt) => {
                  evt.stopPropagation();
                  action.action();
                  handleClose();
                }}
              >
                {action.title}
              </Button>
            ))}
        </div>
      </Popover>
    </div>
  );
};

export default COEEllipsisPopover;
